import { ArrowRight } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowThickRight = mkIcon(ArrowRight);